import React from 'react';
import cls from './EstimateMeasurementsModalHeader.module.css';
import { useTranslation } from 'react-i18next';

export const EstimateMeasurementsModalHeader = () => {
    const { t } = useTranslation();

    return (
        <div className={cls.container}>
            <span className={cls.ModalTitle}>
                {t('EstimateMeasurementsModalHeader.return.ModalTitle')}
            </span>
            <span className={cls.ModalDescription}>
                {t('EstimateMeasurementsModalHeader.return.ModalDescription')}{' '}
            </span>
        </div>
    );
};
